import * as React from "react";
import { useState, useCallback, useContext } from "react";
import classnames from "classnames";
import { MyNumberInputTemplateProps } from "@graffer-inc/form-generator";
import { ModifyingMyNumber } from "../../../../application/domain/form-model/modify-mynumber-exchanger";
import { reportAsyncError } from "@graffer-inc/smart-apply";
import { PatternFormat } from "react-number-format";
import {
  FormContext,
  useMyNumberRefKeyExchanger,
} from "@graffer-inc/form-generator";

export const MyNumberModifyInput: React.FC<MyNumberInputTemplateProps> = ({
  config,
  value,
  setValue,
  onBlur,
  onFocus,
  error,
  touched,
  disabled,
}) => {
  const {
    modificationContext: { detector },
  } = useContext(FormContext);
  const originalValue = detector?.getOriginalValue(config);
  const { valueToRefKey, refkeyToValue, clearRefKey } =
    useMyNumberRefKeyExchanger();
  const [rawValue, setRawValue] = useState<ModifyingMyNumber | undefined>(
    value !== undefined && value !== ""
      ? (refkeyToValue(value) as ModifyingMyNumber)
      : undefined,
  );
  const [decrypted, setDecrypted] = useState<string | undefined>();
  const requestDecrypt = useCallback(async () => {
    try {
      const myNumber = await (rawValue as any).requestDecrypt(originalValue);
      setDecrypted(myNumber);
    } catch (e) {
      reportAsyncError(e);
    }
  }, [setDecrypted, rawValue, originalValue]);
  const setMyNumber = useCallback(
    (mynumber: string) => {
      const refKey = valueToRefKey(mynumber, value);
      setValue(refKey);
      setRawValue({
        refKey: refKey,
        value: mynumber,
        isModified: true,
        myNumber: mynumber,
      });
    },
    [valueToRefKey, value, setValue, setRawValue],
  );
  const clearMyNumber = useCallback(() => {
    clearRefKey(value as string);
    setValue("");
    setRawValue(undefined);
  }, [clearRefKey, value, setValue]);

  if (rawValue !== undefined && !rawValue.isModified) {
    return (
      <div
        className="columns is-vcentered is-mobile is-marginless is-paddingless"
        style={{
          borderRadius: "6px",
          border: "2px solid rgb(245, 245, 245)",
          padding: "2px",
        }}
      >
        <div className="column">
          <p className="title is-size-6">
            {decrypted ? (
              decrypted
            ) : (
              <>
                ************{" "}
                <span className="icon c-hoverable" onClick={requestDecrypt}>
                  <i className="fas fa-eye-slash" />
                </span>
              </>
            )}
          </p>
        </div>
        <div className="column is-narrow">
          <span
            data-testid={`${config.formFieldId}_delete`}
            className="icon c-is-filedrop-hoverable is-clickable"
            onClick={clearMyNumber}
          >
            <i className="fas fa-trash" />
          </span>
        </div>
      </div>
    );
  }

  return (
    <>
      {decrypted && <p>{decrypted}</p>}
      <PatternFormat
        type="text"
        inputMode="numeric"
        name={config.formFieldId}
        data-testid={`${config.formFieldId}_view`}
        className={classnames("input", {
          "is-success": !error && (touched || value),
          "is-danger": !!error && touched,
        })}
        value={rawValue?.myNumber || ""}
        onValueChange={(e) => {
          if (e.value === "") {
            // 値がなくなったらRefKeyをクリアする
            clearMyNumber();
          } else {
            setMyNumber(e.value);
          }
        }}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
        format="#### #### ####"
      />
    </>
  );
};
